module.exports = __webpack_public_path__ + "img/profil.0d27572c.png";